import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "Chinexpress_a2hs_dismissed_v1";

/**
 * Invite à ajouter l'app aux raccourcis / écran d'accueil (PWA).
 * - Chrome/Android : beforeinstallprompt
 * - iOS Safari : instructions manuelles
 */
const AddToHomeScreenPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
    } catch {
      return;
    }

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (isStandalone) return;

    const ua = window.navigator.userAgent || "";
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const onBip = (e) => {
      e.preventDefault();
      setDeferred(e);
      setTimeout(() => setVisible(true), 2500);
    };
    window.addEventListener("beforeinstallprompt", onBip);

    if (isIOS) {
      const t = setTimeout(() => {
        setIosHint(true);
        setVisible(true);
      }, 4000);
      return () => {
        window.removeEventListener("beforeinstallprompt", onBip);
        clearTimeout(t);
      };
    }

    return () => window.removeEventListener("beforeinstallprompt", onBip);
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch {
      /* ignore */
    }
    setDeferred(null);
    dismiss();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-20 left-3 right-3 z-[900] max-w-lg mx-auto">
      <div className="bg-white rounded-2xl shadow-lg border border-orange-100 px-4 py-3.5 flex gap-3 items-start">
        <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center shrink-0">
          {iosHint ? (
            <Share className="w-5 h-5 text-orange-500" />
          ) : (
            <Download className="w-5 h-5 text-orange-500" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-gray-900">Ajouter Chinexpress</p>
          <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">
            {iosHint
              ? "Appuie sur Partager puis « Sur l'écran d'accueil » pour un accès rapide."
              : "Ajoute l'app à tes raccourcis pour commander plus vite."}
          </p>
          {!iosHint && deferred && (
            <button
              type="button"
              onClick={install}
              className="mt-2 text-xs font-bold text-orange-600"
            >
              Ajouter aux raccourcis
            </button>
          )}
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="w-7 h-7 rounded-full flex items-center justify-center text-gray-400 shrink-0"
          aria-label="Fermer"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AddToHomeScreenPrompt;
